import { NoOrdersCard, NoOrdersContent, ReceiptIcon } from './styles';

export const NoCardItem = () => (
  <NoOrdersCard>
    <NoOrdersContent>
      <ReceiptIcon src={'/public/receipt-with-capsule-logo.svg'} alt="Receipt icon" />
      <p>You currently have no orders.</p>
    </NoOrdersContent>
  </NoOrdersCard>
);
